import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../../enums';

const Component = () => import('./Overview.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.OVERVIEW),
  name: SitesRouteNames.SITE_OVERVIEW,
  component: Component,
} as RouteRecordRaw;
